import { render, staticRenderFns } from "./Edit02.vue?vue&type=template&id=b8ffb202&scoped=true&"
import script from "./Edit02.vue?vue&type=script&lang=ts&"
export * from "./Edit02.vue?vue&type=script&lang=ts&"
import style0 from "./Edit02.vue?vue&type=style&index=0&id=b8ffb202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ffb202",
  null
  
)

export default component.exports